import type { FC } from "react";
import { Link } from "react-router";

export const BackLink: FC<{ slug: string }> = ({ slug }) => (
  <Link
    to={`/orders/${slug}`}
    className="mb-6 inline-block text-neutral-500 text-xs hover:text-neutral-900"
  >
    ← 注文詳細
  </Link>
);
